import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { type ReactNode } from 'react';
import pjson from '../../package.json';
import Image from '../_tools/Image';
import { LEAD } from '../vars';

type LandingPageProps = {
    children: ReactNode;
    gray?: boolean;
};

export default function LandingPage(props: LandingPageProps) {
    const { children, gray } = props;
    const logoWhite = !LEAD ? '/images/logos/support.png' : '/images/logos/logo.png';

    return (
        <Box sx={{ height: 'calc(100vh - 32px)', width: 'calc(100vw - 32px)' }}>
            <div
                style={{
                    backgroundPosition: 'center center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundColor: '#555',
                    backgroundImage: `url(/images/loginBG.jpg?v=${pjson?.version})`,
                    filter: gray ? 'grayscale(100%) brightness(60%)' : 'brightness(60%)',
                    zIndex: -99999,
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                }}
            />
            <Stack justifyContent="center" sx={{ height: 1, maxWidth: { xs: '100%', sm: 600 }, pl: { xs: 0, sm: 10, md: 14, lg: 18 } }}>
                <Stack direction="row" alignItems="flex-end" gap={1} sx={{ mt: 16 }}>
                    <Image
                        contain
                        disablePlaceholder
                        ratio={[1347, 260]}
                        src={logoWhite}
                        alt={!LEAD ? 'AHD Cars Support' : 'AHD Cars'}
                        sx={{ filter: gray ? 'grayscale(100%)' : undefined, width: 290 }}
                    />
                    {!LEAD && (
                        <Typography color="common.white" sx={{ mb: 2.5 }}>
                            Support
                        </Typography>
                    )}
                </Stack>
                {children}
                <Stack direction="row" gap={2} alignItems="flex-end" sx={{ flexGrow: 1, mb: 4 }}>
                    <Image
                        alt="Autohaus Digital"
                        contain
                        disablePlaceholder
                        onClick={() => window.open('https://autohaus-digital.de/produkt/car-desk', '_blank')}
                        objectPosition="left center"
                        ratio={[336, 53]}
                        src="/images/logos/autohausDigital_white.png"
                        sx={{ filter: gray ? 'grayscale(100%)' : undefined, cursor: 'pointer' }}
                    />
                </Stack>
            </Stack>
        </Box>
    );
}
